import { render, staticRenderFns } from "./SupplierOrders.vue?vue&type=template&id=a56abdb8&"
import script from "./SupplierOrders.vue?vue&type=script&lang=js&"
export * from "./SupplierOrders.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrders.vue?vue&type=style&index=0&id=a56abdb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports